import React from 'react'
import styled from 'styled-components'

const LegendText = styled.text`
  alignment-baseline: middle;
`
const LegendRect = styled.rect`
  fill: ${props => props.fill};
  stroke: ${props => props.stroke};
`

const Legend = ({ colors, rowHeight, rectSize }) =>
  colors.map((c, i) => (
    <g key={i} transform={`translate(0,${rowHeight * i})`}>
      <LegendRect
        y={(rowHeight - rectSize) / 2}
        width={rectSize}
        height={rectSize}
        fill={c.fill}
        stroke={c.stroke}
      />
      <LegendText transform={`translate(${rectSize * 1.5},${rowHeight / 2})`}>
        {c.text}
      </LegendText>
    </g>
  ))

export default Legend
